export default __webpack_public_path__ + "static/media/bowmaster.a548c974.png";